import React from "react";
import styles from "./styles.module.css";
import { useSelector } from "react-redux";

export default function SmallCardKPI({ key, data }) {
  const { theme } = useSelector((state) => state.theme);

  return (
    <div key={key} className="w-full ml-3">
      <div
        className={`d-flex flex-column gap-1   mt-5 ${
          theme === "light"
            ? "bg-secondaryColor text-primaryColor"
            : "bg-darkThirsary text-darkSecondary"
        } `}
      >
        <h1 className="text-xl font-bold  ml-3 ">{data.heading}</h1>
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 mt-3 ml-3 mr-2`}
        >
          {data.contents.length
            ? data.contents.map(({ Icon, label, count }, i) => (
                <div
                  key={i}
                  className={`${styles.kpiCard}  p-4  flex justify-center items-center flex-col gap-4 border`}
                >
                  <p className={`${styles.pIcon} text-green700`}>
                    <Icon />
                  </p>
                  <p className="font-bold text-lg ">{count}</p>
                  <p className="font-bold text-lg ">{label}</p>
                </div>
              ))
            : ""}
        </div>
      </div>
    </div>
  );
}
